(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBS(root){
    var track=root.querySelector('[data-bs-track]');
    if(!track) return;
    var prev=root.querySelector('[data-bs-prev]'), next=root.querySelector('[data-bs-next]');
    var arrows=root.querySelector('.bs-arrows'), progWrap=root.querySelector('[data-bs-prog]');
    var bar=root.querySelector('[data-bs-prog] i');
    function step(){ var c=track.querySelector('.bs-card'); return c?c.offsetWidth+18:320; }
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step()*2,behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step()*2,behavior:'smooth'});});
    function prog(){ if(!bar)return; var max=track.scrollWidth-track.clientWidth; var r=max>0?track.scrollLeft/max:0; bar.style.left=(r*70)+'%'; }
    function updateNav(){
      var scrollable=track.scrollWidth>track.clientWidth+4;
      if(arrows)arrows.style.display=scrollable?'':'none';
      if(progWrap)progWrap.style.visibility=scrollable?'':'hidden';
    }
    track.addEventListener('scroll',prog,{passive:true}); prog();
    updateNav();
    window.addEventListener('resize',updateNav);
  }
  document.querySelectorAll('.bs').forEach(initBS);
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.bs');if(r)initBS(r);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-brand-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-bh]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;el.classList.add('in');
      el.querySelectorAll('.bh-pic').forEach(function(p,k){setTimeout(function(){p.classList.add('in')},200+k*120)});o.disconnect();});},{threshold:.2}).observe(el);}
  document.querySelectorAll('.bh[data-bh]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-brand-milestones"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-ml]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;el.classList.add('in');
      el.querySelectorAll('.ml-ms').forEach(function(m,k){setTimeout(function(){m.classList.add('in')},k*120)});o.disconnect();});},{threshold:.25}).observe(el);}
  document.querySelectorAll('.ml[data-ml]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-brand-origin"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-og]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;
      el.querySelectorAll('.og-ph').forEach(function(p,k){setTimeout(function(){p.classList.add('in')},k*120)});o.disconnect();});},{threshold:.2}).observe(el);}
  document.querySelectorAll('.og[data-og]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-brand-stats"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-st]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;
      el.querySelectorAll('.st-cell').forEach(function(c,k){setTimeout(function(){c.classList.add('in')},k*90)});
      el.querySelectorAll('[data-count]').forEach(function(n){var target=parseFloat(n.dataset.count)||0,dec=parseInt(n.dataset.dec||'0',10),t0=null;
        function step(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/1400);p=1-Math.pow(1-p,3);n.textContent=(target*p).toFixed(dec);if(p<1)requestAnimationFrame(step);}
        requestAnimationFrame(step);});
      o.disconnect();});},{threshold:.35}).observe(el);}
  document.querySelectorAll('.st[data-st]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-brand2"] && !Shopify.designMode) return;
  try {
    
(function(){
  function run(root){
    var els=root.querySelectorAll('.b2-rv');
    if(!els.length) return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);} });
    },{threshold:.16});
    els.forEach(function(el,i){
      var p=el.parentElement;
      var stag=p&&(p.classList.contains('pr-grid')||p.classList.contains('gl-grid')||p.classList.contains('nb-in'));
      el.style.transitionDelay=(stag?(i%4)*0.08:0)+'s';
      io.observe(el);
    });
  }
  document.querySelectorAll('.b2').forEach(function(b){run(b);});
  document.addEventListener('shopify:section:load',function(e){var b=e.target.querySelector('.b2');if(b)run(b);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCol(root){
    var grid=root.querySelector('#grGrid'); if(!grid) return;
    var cards=[].slice.call(grid.querySelectorAll('.gr-card'));
    var promo=grid.querySelector('#grPromo');
    var empty=grid.querySelector('#grEmpty');
    var chipBox=root.querySelector('#tbChips');
    var countEl=root.querySelector('#tbCount');
    var priceEl=root.querySelector('#flPrice');
    var priceValEl=root.querySelector('#flPriceVal');
    var sortEl=root.querySelector('#tbSort');
    var panel=root.querySelector('#flPanel');
    var overlay=root.querySelector('#flOverlay');
    var total=cards.length;
    var cl=root.querySelector('.cl'),tb=root.querySelector('.tb');
    // Sparse collection: too few products for a filter sidebar to be useful
    if(total<=2){ if(cl)cl.classList.add('sparse'); if(tb)tb.classList.add('sparse-tb'); }
    var CATN={};
    root.querySelectorAll('#flCut .fl-row').forEach(function(r){CATN[r.dataset.v]=r.textContent.replace(/[✓\d]/g,'').trim();});

    var data=cards.map(function(el,idx){
      return {el:el,
        cats:(el.dataset.cat||'').split(/\s+/).filter(Boolean),
        colors:(el.dataset.colors||'').split(/\s+/).filter(Boolean),
        price:parseFloat(el.dataset.price)||0,
        deal:(el.dataset.deal||'').split(/\s+/).filter(Boolean),
        order:parseInt(el.dataset.order,10)||idx,
        created:parseInt(el.dataset.created,10)||0};
    });

    var maxPrice=priceEl?parseInt(priceEl.max,10):9999;
    var st={cats:[],colors:[],price:maxPrice,deals:[],sort:'featured'};
    var urlCat=new URLSearchParams(location.search).get('cat');
    if(urlCat&&urlCat!=='all')st.cats=[urlCat];

    function match(d){
      if(st.cats.length&&!st.cats.some(function(c){return d.cats.indexOf(c)>=0}))return false;
      if(st.colors.length&&!d.colors.some(function(c){return st.colors.indexOf(c)>=0}))return false;
      if(d.price>st.price)return false;
      if(st.deals.length&&!st.deals.some(function(x){return d.deal.indexOf(x)>=0}))return false;
      return true;
    }
    function render(){
      var vis=data.filter(match);
      if(st.sort==='price-asc')vis.sort(function(a,b){return a.price-b.price});
      else if(st.sort==='price-desc')vis.sort(function(a,b){return b.price-a.price});
      else if(st.sort==='newest')vis.sort(function(a,b){return b.created-a.created});
      else vis.sort(function(a,b){return a.order-b.order});
      data.forEach(function(d){d.el.classList.add('hidden')});
      vis.forEach(function(d){d.el.classList.remove('hidden');grid.insertBefore(d.el,empty||null);});
      if(promo){if(vis.length>=1){grid.insertBefore(promo,empty||null);promo.style.display='';}else{promo.style.display='none';}}
      if(empty)empty.classList.toggle('show',vis.length===0);
      if(countEl)countEl.innerHTML='<b>'+vis.length+'</b> of '+total+' products';
      renderChips();
      updateCounts();
    }
    function updateCounts(){
      // category rows: count + hide 0
      root.querySelectorAll('#flCut .fl-row').forEach(function(r){var v=r.dataset.v;
        var n=data.filter(function(d){return d.cats.indexOf(v)>=0}).length;
        var ct=r.querySelector('.ct');if(ct)ct.textContent=n||'';
        r.classList.toggle('hidden',n===0);});
      // color swatches: hide 0
      root.querySelectorAll('#flColor .fl-sw').forEach(function(s){var v=s.dataset.v;
        var n=data.filter(function(d){return d.colors.indexOf(v)>=0}).length;
        s.classList.toggle('hidden',n===0);});
      // deal rows: count + hide 0
      root.querySelectorAll('.ct[data-ct-deal]').forEach(function(c){var t=c.getAttribute('data-ct-deal');
        var n=data.filter(function(d){return d.deal.indexOf(t)>=0}).length;c.textContent=n||'';
        var row=c.closest('.fl-row');if(row)row.classList.toggle('hidden',n===0);});
      // hide a filter group if it has no visible rows/swatches
      root.querySelectorAll('.fl-group').forEach(function(g){
        var items=g.querySelectorAll('.fl-row,.fl-sw');
        if(!items.length)return;
        var anyVisible=[].slice.call(items).some(function(i){return !i.classList.contains('hidden')});
        g.classList.toggle('hidden',!anyVisible);});
    }
    function chip(label,t,v){return '<span class="tb-chip"><b>'+label+'</b><span class="x" data-t="'+t+'" data-v="'+v+'">&#10005;</span></span>'}
    function renderChips(){
      if(!chipBox)return;
      var html='<button class="tb-filter-btn" id="tbFilterBtn">&#9776; Filters</button>';
      st.cats.forEach(function(c){html+=chip(CATN[c]||c,'cat',c)});
      st.colors.forEach(function(c){html+=chip(c.charAt(0).toUpperCase()+c.slice(1),'color',c)});
      st.deals.forEach(function(d){html+=chip(d==='sale'?'On sale':'New','deal',d)});
      if(st.price<maxPrice)html+=chip('≤ $'+st.price,'price','');
      var n=st.cats.length+st.colors.length+st.deals.length+(st.price<maxPrice?1:0);
      if(n)html+='<button class="tb-clear" data-clear-all>Clear all</button>';
      chipBox.innerHTML=html;
      chipBox.querySelectorAll('.tb-chip .x').forEach(function(x){
        x.addEventListener('click',function(){var t=x.dataset.t,v=x.dataset.v;
          if(t==='cat')st.cats=st.cats.filter(function(i){return i!==v});
          if(t==='color')st.colors=st.colors.filter(function(i){return i!==v});
          if(t==='deal')st.deals=st.deals.filter(function(i){return i!==v});
          if(t==='price'){st.price=maxPrice;if(priceEl)priceEl.value=maxPrice;if(priceValEl)priceValEl.textContent='$'+maxPrice}
          syncUI();render();});
      });
      bindFilterBtn();
    }
    function clearAll(){st.cats=[];st.colors=[];st.deals=[];st.price=maxPrice;st.sort='featured';
      if(priceEl)priceEl.value=maxPrice;if(priceValEl)priceValEl.textContent='$'+maxPrice;if(sortEl)sortEl.value='featured';syncUI();render();}
    root.querySelectorAll('[data-clear-all]').forEach(function(b){b.addEventListener('click',clearAll)});
    function syncUI(){
      root.querySelectorAll('#flCut .fl-row').forEach(function(r){r.classList.toggle('on',st.cats.indexOf(r.dataset.v)>=0)});
      root.querySelectorAll('#flDeal .fl-row').forEach(function(r){r.classList.toggle('on',st.deals.indexOf(r.dataset.v)>=0)});
      root.querySelectorAll('#flColor .fl-sw').forEach(function(s){s.classList.toggle('on',st.colors.indexOf(s.dataset.v)>=0)});
    }
    var cut=root.querySelector('#flCut');
    if(cut)cut.addEventListener('click',function(e){var r=e.target.closest('.fl-row');if(!r)return;
      var v=r.dataset.v,i=st.cats.indexOf(v);i<0?st.cats.push(v):st.cats.splice(i,1);syncUI();render();});
    var deal=root.querySelector('#flDeal');
    if(deal)deal.addEventListener('click',function(e){var r=e.target.closest('.fl-row');if(!r)return;
      var v=r.dataset.v,i=st.deals.indexOf(v);i<0?st.deals.push(v):st.deals.splice(i,1);syncUI();render();});
    var color=root.querySelector('#flColor');
    if(color)color.addEventListener('click',function(e){var s=e.target.closest('.fl-sw');if(!s)return;
      var v=s.dataset.v,i=st.colors.indexOf(v);i<0?st.colors.push(v):st.colors.splice(i,1);syncUI();render();});
    if(priceEl){priceEl.addEventListener('input',function(){st.price=+priceEl.value;if(priceValEl)priceValEl.textContent='$'+st.price;});
      priceEl.addEventListener('change',render);}
    if(sortEl)sortEl.addEventListener('change',function(e){st.sort=e.target.value;render();});
    root.querySelectorAll('.fl-head').forEach(function(h){h.addEventListener('click',function(){h.parentElement.classList.toggle('closed')});});
    function bindFilterBtn(){var btn=root.querySelector('#tbFilterBtn');
      if(btn&&panel&&overlay)btn.addEventListener('click',function(){panel.classList.add('open');overlay.classList.add('open');});}
    function closeDrawer(){if(panel)panel.classList.remove('open');if(overlay)overlay.classList.remove('open');}
    var fc=root.querySelector('#flClose');if(fc)fc.addEventListener('click',closeDrawer);
    if(overlay)overlay.addEventListener('click',closeDrawer);
    if(priceEl){st.price=maxPrice;priceEl.value=maxPrice;if(priceValEl)priceValEl.textContent='$'+maxPrice;}
    // clickable color dots on cards → swap card main image
    grid.addEventListener('click',function(e){
      var dot=e.target.closest('.gr-dot');if(!dot||!dot.dataset.img)return;
      var card=dot.closest('.gr-card');if(!card)return;
      var img=card.querySelector('[data-card-img]');if(img)img.src=dot.dataset.img;
      card.querySelectorAll('.gr-dot').forEach(function(d){d.classList.remove('on')});
      dot.classList.add('on');
    });
    (function(){var pre=function(){grid.querySelectorAll('.gr-dot[data-img]').forEach(function(d){var im=new Image();im.src=d.dataset.img;});};
      if('requestIdleCallback' in window){requestIdleCallback(pre);}else{setTimeout(pre,600);}})();
    syncUI();render();
  }
  document.querySelectorAll('.cl').forEach(function(cl){initCol(cl.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){initCol(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-header"]) return;
  try {
    
(function(){
  function q(s,r){return (r||document).querySelector(s);}
  function qa(s,r){return [].slice.call((r||document).querySelectorAll(s));}
  // mobile drawer
  var mnav=q('[data-mnav]'), ov=q('[data-mnav-overlay]');
  function toggle(open){ if(!mnav||!ov)return; mnav.classList.toggle('open',open); ov.classList.toggle('open',open); document.body.style.overflow=open?'hidden':''; }
  var openBtn=q('[data-mnav-open]'), closeBtn=q('[data-mnav-close]');
  if(openBtn)openBtn.addEventListener('click',function(){toggle(true);});
  if(closeBtn)closeBtn.addEventListener('click',function(){toggle(false);});
  if(ov)ov.addEventListener('click',function(){toggle(false);});
  // mobile accordion
  qa('[data-mnav-acc]').forEach(function(btn){
    btn.addEventListener('click',function(){ btn.closest('.mnav-acc').classList.toggle('is-open'); });
  });
  // editorial mega hover preview
  qa('.nav-mega--ed').forEach(function(mega){
    var right=q('[data-nme-right]',mega); if(!right)return;
    var img=q('[data-nme-img]',right), cap=q('[data-nme-cap]',right);
    var eb=q('[data-nme-eb]',right), ti=q('[data-nme-ti]',right), su=q('[data-nme-su]',right);
    var btn=q('[data-nme-btn]',right), btnLink=q('[data-nme-btn-link]',right), mediaLink=q('[data-nme-media-link]',right);
    var d=right.dataset;
    var def={img:d.defImg,eb:d.defEb,ti:d.defTi,su:d.defSu,btn:d.defBtn,href:d.defHref};
    var cur=def.img;
    // preload item images
    qa('.nme-lnk',mega).forEach(function(a){ if(a.dataset.img){var im=new Image();im.src=a.dataset.img;} });
    function setImg(src){ if(!src||src===cur)return; cur=src; img.style.opacity='0'; var tmp=new Image(); tmp.onload=function(){img.src=src;img.style.opacity='1';}; tmp.src=src; }
    function apply(o){
      setImg(o.img);
      if(cap){cap.classList.add('swapping');}
      setTimeout(function(){
        if(eb)eb.textContent=o.eb||''; if(ti)ti.textContent=o.ti||''; if(su)su.textContent=o.su||''; if(btn)btn.textContent=o.btn||'';
        if(o.href){ if(btnLink)btnLink.setAttribute('href',o.href); if(mediaLink)mediaLink.setAttribute('href',o.href); }
        if(cap)cap.classList.remove('swapping');
      },160);
    }
    qa('.nme-lnk',mega).forEach(function(a){
      a.addEventListener('mouseenter',function(){ apply({img:a.dataset.img,eb:a.dataset.group,ti:a.dataset.name,su:a.dataset.tag,btn:a.dataset.btn,href:a.dataset.href}); });
    });
    var cols=q('.nme-cols',mega);
    if(cols)cols.addEventListener('mouseleave',function(){ apply(def); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHero(root){
    var slides=root.querySelectorAll('.hero-slide');
    var dots=root.querySelectorAll('.hero-dot');
    if(slides.length<1) return;
    var DUR=parseInt(root.getAttribute('data-interval'),10)||6000,cur=0,timer=null;
    function go(i){cur=(i+slides.length)%slides.length;slides.forEach(function(s,k){s.classList.toggle('active',k===cur);});dots.forEach(function(d,k){d.classList.toggle('active',k===cur);});restart();}
    function restart(){clearInterval(timer);if(slides.length>1)timer=setInterval(function(){go(cur+1);},DUR);}
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);});});
    var sx=0;
    root.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    root.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>50)go(cur+(dx<0?1:-1));},{passive:true});
    restart();
  }
  document.querySelectorAll('[data-wander-hero]').forEach(initHero);
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('[data-wander-hero]');if(r)initHero(r);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-attributes"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-pa]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;
      el.querySelectorAll('.pa-row,.pa-pic').forEach(function(x,k){setTimeout(function(){x.classList.add('in')},k*130)});o.disconnect();});},{threshold:.2}).observe(el);}
  document.querySelectorAll('.pa[data-pa]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-benefits"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-bn]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;
      el.querySelectorAll('.bn-col').forEach(function(c,k){setTimeout(function(){c.classList.add('in')},k*120)});o.disconnect();});},{threshold:.25}).observe(el);}
  document.querySelectorAll('.bn[data-bn]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-features3"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var grid=root.querySelector('[data-f3]');if(!grid)return;
    var cards=grid.querySelectorAll('.f3-card');
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(e.isIntersecting){cards.forEach(function(c,k){setTimeout(function(){c.classList.add('in')},k*140)});o.disconnect();}});},{threshold:.2}).observe(grid);}
  document.querySelectorAll('.f3 [data-f3]').forEach(function(g){reveal(g.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-sg]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;
      el.querySelectorAll('.sg-row.cur,.sg-row.next').forEach(function(r){r.classList.add('in')});o.disconnect();});},{threshold:.3}).observe(el);}
  document.querySelectorAll('.sg[data-sg]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-material"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-pm]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;el.classList.add('in');
      el.querySelectorAll('[data-count]').forEach(function(n){var target=+n.dataset.count,dec=(''+n.dataset.count).indexOf('.')>=0?1:0,t0=null;
        function step(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/1400);p=1-Math.pow(1-p,3);n.textContent=(target*p).toFixed(dec);if(p<1)requestAnimationFrame(step);}
        requestAnimationFrame(step);});
      o.disconnect();});},{threshold:.35}).observe(el);}
  document.querySelectorAll('.pm[data-pm]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-related"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-ym]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;
      el.querySelectorAll('.ym-card').forEach(function(c,k){setTimeout(function(){c.classList.add('in')},k*120)});o.disconnect();});},{threshold:.15}).observe(el);}
  document.querySelectorAll('.ym[data-ym]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-scenes"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-sc]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(!e.isIntersecting)return;
      el.querySelectorAll('.sc-tile').forEach(function(t,k){setTimeout(function(){t.classList.add('in')},k*140)});o.disconnect();});},{threshold:.15}).observe(el);}
  document.querySelectorAll('.sc[data-sc]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-pdp-textimage"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reveal(root){var el=root.querySelector('[data-ti]');if(!el)return;
    new IntersectionObserver(function(es,o){es.forEach(function(e){if(e.isIntersecting){el.classList.add('in');o.disconnect();}});},{threshold:.25}).observe(el);}
  document.querySelectorAll('.ti[data-ti]').forEach(function(el){reveal(el.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPDP(root){
    var form=root.querySelector('#pdpForm'); if(!form) return;
    var dataEl=root.querySelector('[data-pdp-variants]'); if(!dataEl) return;
    var variants; try{ variants=JSON.parse(dataEl.textContent); }catch(e){ return; }
    var moneyFmt=(window.Shopify&&Shopify.money_format)||'${{amount}}';
    function money(cents){
      var v=(cents/100).toFixed(2);
      return moneyFmt.replace(/\{\{\s*amount\s*\}\}/,v).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(cents/100));
    }
    var idInput=root.querySelector('#pdpVarId'),qtyInput=root.querySelector('#pdpQty'),qtyVal=root.querySelector('#qtyVal');
    var nowEl=root.querySelector('#bbNow'),wasEl=root.querySelector('#bbWas'),saveEl=root.querySelector('#bbSave');
    var atc=root.querySelector('#bbAtc'),atcText=root.querySelector('#bbAtcText'),atcPrice=root.querySelector('#bbAtcPrice');
    var colorName=root.querySelector('#bbColorName'),sizeName=root.querySelector('#bbSizeName');
    var gaMain=root.querySelector('#gaMain'),thumbs=[].slice.call(root.querySelectorAll('.ga-th'));
    // Preload full-size main images so variant/thumb switching is instant (no CDN fetch lag)
    var _preloaded={};
    function preload(src){if(!src||_preloaded[src])return;_preloaded[src]=1;var im=new Image();im.src=src;}
    if('requestIdleCallback' in window){requestIdleCallback(function(){thumbs.forEach(function(t){preload(t.dataset.img);});});}
    else{setTimeout(function(){thumbs.forEach(function(t){preload(t.dataset.img);});},400);}
    var swBtns=[].slice.call(root.querySelectorAll('.bb-sw')),szBtns=[].slice.call(root.querySelectorAll('.bb-size'));
    var cur=variants.find(function(v){return v.id==idInput.value})||variants[0];
    var sel={color:cur.color,size:cur.size};

    function slug(s){return (s||'').toString().toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')}
    function filterGallery(color){
      var cs=slug(color),shown=[];
      thumbs.forEach(function(t){var tc=t.dataset.color||'';var ok=!cs||!tc||tc===cs;t.classList.toggle('hidden',!ok);if(ok)shown.push(t);});
      if(!shown.length){thumbs.forEach(function(t){t.classList.remove('hidden')});shown=thumbs;}
      thumbs.forEach(function(t){t.classList.remove('on')});
      shown[0].classList.add('on');
      setMain(shown[0].dataset.img);
    }
    function setMain(src){if(!src||!gaMain)return;gaMain.src=src;gaMain.classList.remove('swap');void gaMain.offsetWidth;gaMain.classList.add('swap');}
    function findVariant(){return variants.find(function(v){return v.color===sel.color&&v.size===sel.size})}
    function updateSizes(){
      szBtns.forEach(function(b){
        var s=b.dataset.size;var v=variants.find(function(x){return x.color===sel.color&&x.size===s});
        b.classList.toggle('oos',!(v&&v.available));
      });
    }
    function update(){
      var v=findVariant();
      if(colorName)colorName.textContent=sel.color;
      if(sizeName)sizeName.textContent=sel.size;
      swBtns.forEach(function(b){b.classList.toggle('on',b.dataset.color===sel.color)});
      szBtns.forEach(function(b){b.classList.toggle('on',b.dataset.size===sel.size)});
      updateSizes();
      if(v){
        idInput.value=v.id;
        if(nowEl)nowEl.textContent=money(v.price);
        if(wasEl){if(v.compare>v.price){wasEl.textContent=money(v.compare);wasEl.hidden=false;
          if(saveEl){saveEl.textContent='Save '+Math.round((1-v.price/v.compare)*100)+'%';saveEl.hidden=false;}}
          else{wasEl.hidden=true;if(saveEl)saveEl.hidden=true;}}
        if(atc){atc.disabled=!v.available;}
        if(atcText)atcText.textContent=v.available?'Add to Cart':'Sold Out';
        if(atcPrice){atcPrice.textContent=v.available?money(v.price):'';atcPrice.style.display=v.available?'':'none';}
      }else{
        if(atc)atc.disabled=true;if(atcText)atcText.textContent='Unavailable';if(atcPrice)atcPrice.textContent='';
      }
    }
    swBtns.forEach(function(b){b.addEventListener('click',function(){sel.color=b.dataset.color;filterGallery(sel.color);update();})});
    szBtns.forEach(function(b){b.addEventListener('click',function(){if(b.classList.contains('oos'))return;sel.size=b.dataset.size;update();})});
    thumbs.forEach(function(t){t.addEventListener('click',function(){thumbs.forEach(function(x){x.classList.remove('on')});t.classList.add('on');setMain(t.dataset.img);})});
    var minus=root.querySelector('#qtyMinus'),plus=root.querySelector('#qtyPlus');
    function setQty(n){n=Math.max(1,n);qtyInput.value=n;if(qtyVal)qtyVal.textContent=n;}
    if(minus)minus.addEventListener('click',function(){setQty((+qtyInput.value||1)-1)});
    if(plus)plus.addEventListener('click',function(){setQty((+qtyInput.value||1)+1)});
    // accordion
    root.querySelectorAll('.bb-acc-head').forEach(function(h){h.addEventListener('click',function(){h.parentElement.classList.toggle('open')});});
    // initial gallery filter to current color (keep the featured image as main)
    if(thumbs.some(function(t){return t.dataset.color})){
      var cs0=slug(sel.color);
      thumbs.forEach(function(t){var tc=t.dataset.color||'';t.classList.toggle('hidden',!(!cs0||!tc||tc===cs0));});
    }
    update();
  }
  document.querySelectorAll('.pd').forEach(function(pd){initPDP(pd.closest('.shopify-section')||document);});
  document.addEventListener('shopify:section:load',function(e){initPDP(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wander-voice"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCV(root){
    var el=root.querySelector('[data-cv-data]'); if(!el) return;
    var data; try{ data=JSON.parse(el.textContent); }catch(e){ return; }
    if(!data.length) return;
    var q=root.querySelector('[data-cv-quote]'),a=root.querySelector('[data-cv-author]'),
        img=root.querySelector('[data-cv-img]'),cnt=root.querySelector('[data-cv-count]'),
        prev=root.querySelector('[data-cv-prev]'),next=root.querySelector('[data-cv-next]');
    var i=0;
    function show(n){ i=(n+data.length)%data.length; var d=data[i];
      if(q){q.style.opacity=0;setTimeout(function(){q.textContent=d.quote;q.style.opacity=1;},180);}
      if(a)a.textContent=d.author; if(img&&d.img)img.src=d.img;
      if(cnt)cnt.textContent=(i+1)+' / '+data.length; }
    if(prev)prev.addEventListener('click',function(){show(i-1);});
    if(next)next.addEventListener('click',function(){show(i+1);});
  }
  document.querySelectorAll('.cv').forEach(initCV);
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.cv');if(r)initCV(r);});
})();

  } catch(e) { console.error(e); }
})();
})();
